// src/components/Featurgene.js
import React from 'react';
import featurers from '../../../imgs/featurers.webp';
import './Featurgene.css';


const Featurgene = () => {
    return (
        <div className="featu">
            <div>
                <h2 className="featur">FEATURES</h2>

                <img
                    src={featurers}
                    alt="B Machine"
                    className="featurg"data-aos="fade-down"
                />
            </div>

        </div>
    );
};
export default Featurgene;
